import { SortTable } from '../types/SortTable.type';
import { ArrayOfDynamicObjects } from '../types/ArrayOfDynamicObjects.type';
import Order from '../../../enums/order.enum';

const compare = (a: any, b: any, order: Order): number => {
  const isAsc = order === Order.ASC;

  if (a == null && b == null) return 0;
  if (a == null) return isAsc ? -1 : 1;
  if (b == null) return isAsc ? 1 : -1;

  if (!isNaN(Number(a)) && !isNaN(Number(b))) {
    return isAsc ? Number(a) - Number(b) : Number(b) - Number(a);
  }

  if (typeof a === 'boolean' && typeof b === 'boolean') {
    return isAsc ? Number(a) - Number(b) : Number(b) - Number(a);
  }

  if (typeof a === 'string' && typeof b === 'string') {
    return isAsc ? a.localeCompare(b, undefined, { numeric: true }) : b.localeCompare(a, undefined, { numeric: true });
  }

  return isAsc
    ? String(a).localeCompare(String(b), undefined, { numeric: true })
    : String(b).localeCompare(String(a), undefined, { numeric: true });
};

export const sortArray = (array: ArrayOfDynamicObjects, sortOption: SortTable): ArrayOfDynamicObjects => {
  const { order, field } = sortOption;

  return [...array].sort((a, b) => {
    const valueA = a[field];
    const valueB = b[field];

    const valA = valueA ?? null;
    const valB = valueB ?? null;

    return compare(valA, valB, order);
  });
};
